import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Typography from 'WeployDesignLanguage/Typography';

import SearchField from 'WeployDesignLanguage/inputs/SearchField';
import TextField from 'WeployDesignLanguage/inputs/TextField';
import { MenuItem } from 'WeployDesignLanguage/Select';

import MultiSelect from 'LegacyWeployDesignLanguage/inputs/MultiSelect';

const StyledFilterContainer = styled.div`
  ${props => !props.collapsed && css`
    height: 100vh;
    border-right: 1px solid ${props.theme.colors.environment.divider};
    padding: 0 ${props.theme.spacing[3]} 0 ${props.theme.spacing[1]};
  `}

  ${props => props.collapsed && css`
    margin-bottom: ${props.theme.spacing[2]};
  `}
`;

const StyledTypography = styled(Typography)`
  margin-bottom: ${props => props.theme.spacing[4]};
`;

const StyledFilterDivider = styled.div`
  margin-top: ${props => props.theme.spacing[2]};
`;

const Filters = ({
  availabilityOptions,
  currentAvailability,
  collapsed,
  currentLocation,
  currentSkills,
  locationOptions,
  onAvailabilitySelect,
  onLocationSelect,
  onSearchTermClear,
  onSearchTermSubmit,
  onSkillsChange,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleBlur = () => {
    if (!searchTerm) {
      onSearchTermClear();
    }
  };

  return (
    <StyledFilterContainer collapsed={collapsed}>
      <StyledTypography variant="subtitle1">Filters</StyledTypography>
      <SearchField
        id="search"
        name="Search"
        placeholder="Search keywords"
        value={searchTerm}
        onChange={event => setSearchTerm(event.target.value)}
        onSubmit={onSearchTermSubmit}
        onClear={() => {
          setSearchTerm('');
          onSearchTermClear();
        }}
        onBlur={handleBlur}
      />
      <StyledFilterDivider />
      <TextField
        select
        id="location"
        name="location"
        label="Location"
        value={currentLocation}
        onChange={event => onLocationSelect(event.target.value)}
      >
        {
          locationOptions.map(({ key, value }) => (
            <MenuItem key={key} value={value}>{key}</MenuItem>
          ))
        }
      </TextField>
      <StyledFilterDivider />
      <TextField
        select
        id="availability"
        name="availability"
        label="Availability"
        value={currentAvailability}
        onChange={event => onAvailabilitySelect(event.target.value)}
      >
        {
          availabilityOptions.map(({ key, value }) => (
            <MenuItem key={key} value={value}>{key}</MenuItem>
          ))
        }
      </TextField>
      <StyledFilterDivider />
      <MultiSelect
        id="skills"
        name="skills"
        label="Skills, Software and Tools"
        tags={currentSkills}
        placeholder="Outbound, Zendesk, etc"
        onTagsChange={onSkillsChange}
      />
    </StyledFilterContainer>
  );
};


Filters.propTypes = {
  availabilityOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  collapsed: PropTypes.bool,
  currentAvailability: PropTypes.string.isRequired,
  currentLocation: PropTypes.string.isRequired,
  currentSkills: PropTypes.arrayOf(PropTypes.string).isRequired,
  locationOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onAvailabilitySelect: PropTypes.func.isRequired,
  onLocationSelect: PropTypes.func.isRequired,
  onSearchTermClear: PropTypes.func.isRequired,
  onSearchTermSubmit: PropTypes.func.isRequired,
  onSkillsChange: PropTypes.func.isRequired,
};

Filters.defaultProps = {
  collapsed: false,
};

export default Filters;
